import {AnimationGlobalEnum} from './animation-global.enum';

//#region ENUM AnimationPlayStateEnum

/**
 * ### AnimationPlayStateEnum
 * Enum representing possible values for the CSS `animation-play-state` property.
 *
 * This enum is accompanied by:
 * - `AnimationPlayStateEnumHumanReadable` — human-friendly labels.
 * - `AnimationPlayStateEnumType` — a union type of all enum keys.
 *
 * @enum AnimationPlayStateEnum
 * @property PAUSED - The animation is paused.
 * @property RUNNING - The animation is currently playing.
 */
export enum AnimationPlayStateEnum {
  /** The animation is paused. */
  PAUSED = 'paused',

  /** The animation is currently playing. */
  RUNNING = 'running',
}

//#endregion

//#region TYPE AnimationPlayStateEnumType
/**
 * ### AnimationPlayStateEnumType
 * Union type of all keys in `AnimationPlayStateEnum`.
 *
 * @type AnimationPlayStateEnumType
 * @example
 * // Possible values: 'PAUSED' | 'RUNNING'
 */
export type AnimationPlayStateEnumType = keyof typeof AnimationPlayStateEnum;
//#endregion

//#region TYPE AnimationPlayStateType
/**
 * ### AnimationPlayStateType
 * Union type of all keys from `AnimationPlayStateEnum` and `AnimationGlobalEnum`.
 *
 * This type is useful when a value can be either a play-state-specific or global animation keyword.
 *
 * @type AnimationPlayStateType
 * @example
 * // Possible values: 'PAUSED' | 'RUNNING' | 'INHERIT' | 'INITIAL' | 'REVERT' | 'REVERT_LAYER' | 'UNSET'
 */
export type AnimationPlayStateType =
  | keyof typeof AnimationPlayStateEnum
  | keyof typeof AnimationGlobalEnum;
//#endregion
